import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NotificationSetting, PagedNotification } from './notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(public http: HttpClient) { }

  getNotificationsSettings(): Observable<NotificationSetting[]> {
    return this.http.get<NotificationSetting[]>(`${environment.apiUrl}/Notifications/GetNotificationsSettings/${localStorage.currentUserSubscription}`);
  }

  getNotificationSetting(notificationSetting: NotificationSetting): Observable<NotificationSetting> {
    return this.http.post<NotificationSetting>(`${environment.apiUrl}/Notifications/GetNotificationSetting`,notificationSetting);
  }

  addNotificationsSettings(notificationSetting: NotificationSetting): Observable<NotificationSetting> {
    return this.http.post<NotificationSetting>(`${environment.apiUrl}/Notifications/AddNotificationsSettings`, notificationSetting);
  }

  updateNotificationsSettings(notificationSetting: NotificationSetting): Observable<NotificationSetting> {
    return this.http.put<NotificationSetting>(`${environment.apiUrl}/Notifications/UpdateNotificationsSettings/${notificationSetting.id}`, notificationSetting);
  }

  deleteNotificationsSettings(settingId: Guid): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/Notifications/DeleteNotificationsSettings/${settingId}`);
  }

  getNotifications(pageNo: number, pageSize: number): Observable<PagedNotification> {
    return this.http.get<PagedNotification>(`${environment.apiUrl}/Notifications/GetNotifications?pageNo=${pageNo}&pageSize=${pageSize}`);
  }

  dismissNotification(notificationId: Guid): Observable<boolean> {
    return this.http.put<boolean>(`${environment.apiUrl}/Notifications/DismissNotification/${notificationId}`, {});
  }

  markNotificationAsRead(notificationId: Guid): Observable<boolean> {
    return this.http.put<boolean>(`${environment.apiUrl}/Notifications/MarkNotificationAsRead/${notificationId}`, {});
  }

  getNotificationsCount(): Observable<number> {
    return this.http.get<number>(`${environment.apiUrl}/Notifications/GetNotificationsCount`);
  }
}
